<div class="container">
    <div mat-dialog-content>
      <mat-card-title class="heading">{{data.mes}}</mat-card-title>
    </div>
      <div class="buttons">
        <button mat-button class="yes-button" (click)="onOKClick()">Ok</button>
      </div>
</div>
